import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Loader } from 'src/component'

const CalculatorLayout = () => {
    return (
        <Suspense fallback={<Loader spin />}>
            <Outlet />
        </Suspense>
    )
}

export default CalculatorLayout;